import type { Maybe } from '@adornis/base/utilTypes.js';
import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import type { Renderable } from '@adornis/functional-lit/renderable.js';
import { logout } from '@adornis/users/client/loginFunctions.js';
import { html, nothing } from 'lit';
import { MatchingWeekRole } from '../../db/enums/roles.js';
import { mainRouter } from '../mainRouter.js';

// TODO (low prio) dirty.. do not accept user
// ? do we really want to check for roles here?
export const adminGuard = (user: Maybe<User>, render: () => Renderable) => {
  if (user?.roles?.some(r => r.name === MatchingWeekRole.ADMIN)) {
    return render();
  }

  return html`
    <section class="min-h-dvh flex items-center justify-center bg-base-200 p-4">
      <div class="max-w-xl w-full">
        <div class="card bg-base-100 shadow-xl">
          <div class="card-body items-center text-center">
            <div class="text-6xl">🚫</div>
            <h1 class="card-title text-2xl">Access denied</h1>
            <p class="text-base-content/70">You don't have permission to view this page.</p>
            <div class="card-actions mt-4">
              <button
                class="btn btn-primary"
                @click=${() => (history.length > 1 ? history.back() : mainRouter.goTo('root'))}
              >
                Go back
              </button>
              <button class="btn btn-ghost" @click=${() => logout().then(() => mainRouter.goTo('root'))}>Logout</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  `;
};

export const roleHide = (user: Maybe<User>, roles: MatchingWeekRole[], render: () => Renderable) => {
  if (user?.roles?.some(r => roles.includes(r.name as MatchingWeekRole))) {
    return render();
  }

  return nothing;
};
